import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import { useEffect, useState } from "react";
import usePostHook from "../../customHooks/usePostHook";
import { yupResolver } from "@hookform/resolvers/yup";
import { invoiceCustomerFormValidation } from "../../utils/formValidation";
import { useForm } from "react-hook-form";
import usePatchHook from "../../customHooks/usePatchHook";
import randString from "../../utils/randomString";
import generateInvoiceHTML from "../Print/invoice";
import { toast } from "react-toastify";
import { useBoolean } from "../../components/PosScreen/globalState/ItemFlag";
import { CompanyLogo } from "../../images";

const InvoiceComponent = loadable(() => import("../../components/Invoice"));

const Invoice = () => {
  const [searchValue, setSearchValue] = useState<any>("");
  const [invoiceId, setInvoiceId] = useState('');
  const { data: tocData, isPending: tocLoading, refetch: tocRefetch } = useGetHook({
    queryKey: [`toc`],
    url: `${APIS.TERMS_OF_CONDITIONS}`,
    params: {
    },
  });
  const { isTrue, toggle, setIsTrue } = useBoolean();

  const { register, handleSubmit, formState: { errors, isDirty }, setValue, getValues, watch, control, reset, trigger, setError, clearErrors } = useForm({
    resolver: yupResolver(invoiceCustomerFormValidation),
    defaultValues: async () => {
      const toc = await tocRefetch();
      const t: string = toc.data.terms_of_conditions
      return ({
        customer: "",
        customer_name: "",
        customer_email: "",
        terms_of_delivery: "In-Store",
        customer_contact_number: "",
        customer_address: "",
        discount_type: "amount",
        discount: "0",
        toc: t,
        sub_total: "0",
        total_gst: "0",
        discount_amount: "0",
        grand_total: "0",
        order_items: [{
          code: '',
          product: "",
          title: '',
          purity: '0',
          rate: '',
          weight: '0',
          wastage: '',
          cut_piece: '',
          total_weight: '0',
          wage: '',
          pote_stone: '',
          grand_total: '0',
        }]
      })
    },
    mode: "all",
  })

  useEffect(() => {
    setIsTrue(isDirty)
  }, [isDirty])
  const { data: customerData, isPending: customerLoading, refetch: customerRefetch } = useGetHook({
    queryKey: [`customer-list`],
    url: `${APIS.CUSTOMER}`,
    params: {
      search: searchValue ? searchValue : ""
    },
  });
  const { isPostLoading, mutateAsync, postData } = usePostHook({
    queryKey: ["invoice"],
    navigateURL: "",
  });
  const id = randString(10)
  const handleGenerateInvoice = async (data: any, total_weight: any) => {
    console.log(data)
    const url = APIS.INVOICE;
    const formData = { ...data, total_weight: total_weight }
    try {
      const res = await mutateAsync({ url, formData, setError });
      setInvoiceId(res?.data?.id)
    }
    catch (e) {
      console.log(e, "Error crating Invoice")
    }
  }
  const { data: productData, isPending: productLoading, refetch: productRefetch } = useGetHook({
    queryKey: ['product-list'],
    url: `${APIS.PRODUCT}`,
    params: {
      available_quantity__gte: 1
    },
  });

  const { refetch } = useGetHook(
    {
      queryKey: [`invoice${invoiceId}`],
      url: `${APIS.INVOICE}${invoiceId}/`,
      enabled: false,
      params: {},
    }
  );
  const handlePrintInvoice = async () => {
    async function getBase64(url: string) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    try {
      const result = await refetch();

      if (!result?.data) {
        console.error("No data returned", result);
        return;
      }

      const invoiceData = result.data;
      const base64Logo = await getBase64(CompanyLogo);
      const image = `<img src="${base64Logo}" alt="Logo" style="width: 90%; height: 90%; object-fit: contain;" />`;

      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (!printWindow) return;

      printWindow.document.open();
      printWindow.document.write(generateInvoiceHTML(invoiceData, null, image));
      printWindow.document.close();

      // WAIT FOR IMAGES TO FINISH LOADING
      const imgs: any = printWindow.document.images;

      if (imgs.length === 0) {
        printWindow.print();
        printWindow.close();
        return;
      }

      let loaded = 0;

      for (let img of imgs) {
        img.onload = () => {
          loaded++;
          if (loaded === imgs.length) {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }
        };

        img.onerror = () => {
          loaded++;
          if (loaded === imgs.length) {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }
        };
      }

    } catch (err) {
      console.error("Error while fetching invoice data:", err);
    }
  };

  const { isPostLoading: isEmailLoading, mutateAsync: emailMutateAsync, postData: emailData } = usePostHook({ queryKey: ["email-send"], navigateURL: null });

  const handleSendEmail = async () => {
    if (invoiceId) {
      const url = `${APIS.INVOICE}${invoiceId}/send-email/`;
      try {
        const res = await emailMutateAsync({ url })
      } catch (e) {
        console.log(e, "Error Sending Email")
      }

    }
  };
  const { isPostLoading: loading, mutateAsync: customerAddMutateAysnc, postData: customerPostData } = usePostHook({ queryKey: ["customer"], navigateURL: null });
  const {
    isLoading,
    mutateAsync: updateCustomerAsync,
    data,
  } = usePatchHook({
    queryKey: [`customer`, `customer-${id}`],
    navigateURL: null,
    message: false
  });

  const handleSaveCustomer = async () => {
    const isValid = await trigger(['customer', 'customer_name', 'customer_email', 'customer_contact_number', 'customer_address']);
    console.log(isValid)
    console.log(getValues())
    if (!isValid) return;
    const { customer, customer_name, customer_email, customer_contact_number, customer_address } = getValues();
    if (customer) {
      const url = `${APIS.CUSTOMER}${customer}/`;
      const formData = {
        name: customer_name,
        address: customer_address,
        contact_number: customer_contact_number,
        email: customer_email
      };
      try {
        const res = await updateCustomerAsync({ url, formData, setError });
        if (res?.status === 200 || res?.status === 201) {
          toast.success("Updated Customer Invoice successfully");
          clearErrors();
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      const url = APIS.CUSTOMER;
      const formData = {
        name: customer_name,
        address: customer_address,
        contact_number: customer_contact_number,
        email: customer_email
      };
      try {
        const res = await customerAddMutateAysnc({ url, formData, setError });
        await customerRefetch();
        if (res?.data?.id) {
          setSearchValue({ id: res?.data?.id, name: res?.data?.name })
        }
      } catch (err: any) {
        console.error("Error creating customer:", err);
        toast.error(err)
      }
    }
  }

  return (<div className="w-full ">
    <InvoiceComponent
      customerData={customerData}
      invoiceId={invoiceId}
      clearErrors={clearErrors}
      setSearchValue={setSearchValue}
      searchValue={searchValue}
      handlePrintInvoice={handlePrintInvoice}
      handleSendEmail={handleSendEmail}
      handleSaveCustomer={handleSaveCustomer}
      register={register}
      productData={productData}
      setError={setError}
      handleSubmit={handleSubmit}
      tocData={tocData}
      errors={errors}
      setValue={setValue}
      getValues={getValues}
      watch={watch}
      control={control}
      handleGenerateInvoice={handleGenerateInvoice}
      reset={reset}
      setInvoiceId={setInvoiceId}
      productRefetch={productRefetch}
    />
  </div>
  )
}

export default Invoice